import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import type React from 'react'
import { type ReactNode, useEffect, useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { ModalAddDialog } from './ModalAddDialog'

type AddButtonProps = {
  children: ReactNode
  title: string
  onAdd: (text: string) => void
}

export const AddButton: React.FC<AddButtonProps> = props => {
  const { onAdd } = props
  const auth = useAuth()
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleSave = (value: string) => {
    setInputValue(value)
  }

  const onClickHandler = async () => {
    handleOpen()
  }

  useEffect(() => {
    if (inputValue) {
      onAdd(inputValue)
      setInputValue('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return (
    <>
      {open && (
        <ModalAddDialog open={open} title={props.title} onClose={handleClose} onSave={handleSave} />
      )}
      <Button
        disabled={auth.isDisable}
        onClick={onClickHandler}
        startIcon={<AddIcon sx={{ width: 40, height: 40, paddingBottom: '6px' }} />}
        sx={{
          marginBottom: '24px',
          justifyContent: 'flex-start',
          color: '#282828',
          font: 'normal normal bold 21px/32px Noto Sans JP',
          paddingTop: '6px',
          paddingLeft: '30px',
          textAlign: 'left',
          backgroundColor: '#fff16f',
          '&:hover': {
            backgroundColor: 'rgba(255, 241, 111, 0.8)',
          },
          boxShadow: '0px 2px 2px #00000014',
          height: '80px',
          width: '400px',
          borderRadius: '40px',
          '& .MuiSvgIcon-root': {
            fontSize: '32px',
          },
        }}
      >
        {props.children}
      </Button>
    </>
  )
}
